import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {useRefraPlanningTracking} from '../tracking'

import {mutations} from '@refra/api/mutations'
import {useRefraMutation} from '@refra/modules/common/hooks'
import {logger} from '@refra/modules/common/utils'

export const useEditShutdown = () => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()
  const tracking = useRefraPlanningTracking()

  return useRefraMutation({
    mutationFn: mutations.editShutdown,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useEditShutdown')
        .extras({errorDetails})
        .error('Error occurred while editing shutdown')

      spawnErrorToast(t('error.editShutdown'))
    },
    onSuccess: async (_, {shutdownId}) => {
      tracking.shutdown.edit(shutdownId)

      await queryClient.invalidateQueries({queryKey: ['shutdowns']})
      spawnSuccessToast(t('success.editShutdown'))
    }
  })
}
